import { MaintenanceActionTypes, LoadSearchEmployerFail, LoadSearchEmployer, LoadSearchEmployerSuccess } from './maintenance.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PeopleFunctionService, EmployerResponseGridResponseBase } from 'src/app/core/services/peopleapi/peoplefunctionapi.services';
import { Injectable } from '@angular/core';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class MaintenanceEffects {
  constructor(private readonly action$: Actions, private readonly peopleService: PeopleFunctionService) { }

  SearchEmployer = createEffect(() => this.action$.pipe(
      ofType(MaintenanceActionTypes.LoadSearchEmployer),
    mergeMap((action: LoadSearchEmployer) => this.peopleService.getEmployerSearch(action.searchParam).pipe(
      map((searchEmployer: EmployerResponseGridResponseBase) =>
        (new LoadSearchEmployerSuccess(searchEmployer.items)))).pipe(
             catchError(error => of(new LoadSearchEmployerFail(error))))

     )));

}
